import Encoding from 'encoding-japanese'

export const createBlobFromLocationCsv = ({
  errorLocationCsv,
  importableLocationCsv,
}) => {
  // 入効可能地点とエラー地点のカラムを追加したテキストを作成
  const outputText =
    errorLocationCsv
      .split('\n')
      .map(row => row + ',Error')
      .join('\n') +
    '\n' +
    importableLocationCsv
      .split('\n')
      .map(row => row + ',OK')
      .join('\n')
  // shit-jis変換
  const unicodeList = Encoding.stringToCode(outputText)
  const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode')
  const shiftJisOutputText = new Uint8Array(shiftJisCodeList)
  return new Blob([shiftJisOutputText], {
    type: 'text/csv;charset=sjis',
  })
}
